import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatMessage } from 'i18n/CurrentLocale';
import * as modalWindowActions from 'root/modal/modalWindowActions';
import * as validation from 'myParkdUtils/validationHandling';
import * as feedbackActions from 'features/support/feedbackActions';
import ErrorMessage from 'components/ErrorMessage';
import SubmitButton from 'components/SubmitButton';

const SendMessageToSupportModal = props => {
    const [message, setMessage] = useState('');
    const [showValidationErrors, setShowValidationErrors] = useState(false);

    function getValidationErrors() {
        let errors = {};
        errors.feedback = validation.checkIfNotNull(message);
        return errors;
    }

    function handleSubmit(e) {
        e.preventDefault();
        const validationSuccessful = validation.validate(getValidationErrors());
        if (validationSuccessful) {
            props.sendMessageToSupport(message);
        } else {
            setShowValidationErrors(true);
        }
    }

    const errors = getValidationErrors();
    const validationSuccessful = validation.validate(errors);

    return (
        <div id="contact-support-modal" className="panel radius-rectangle">
            <div className="panel-header center">
                <h2 className="bold-title">{props.modalContent.title}</h2>
                <button className="btn-close-modal" onClick={props.closeModal} />
            </div>
            <div className="panel-content full-width-form">
                <form
                    onSubmit={handleSubmit}
                    noValidate
                    className={
                        (validationSuccessful ? 'validation-successful ' : '') +
                        (showValidationErrors ? 'show-validation-messages' : 'hide-validation-messages')
                    }
                >
                    <textarea
                        className={'text-field dark-placeholder ' + (errors.feedback ? 'error' : 'valid')}
                        rows="6"
                        placeholder={formatMessage({ id: props.modalContent.textareaPlaceholderId })}
                        autoFocus
                        onChange={e => setMessage(e.target.value)}
                    />

                    <ErrorMessage msg={errors.feedback} />

                    <SubmitButton buttonText={formatMessage({ id: 'GLOBAL_SEND' })} saving={props.messageStatus.isSending} />
                </form>
            </div>
        </div>
    );
};

function mapStateToProps(state, props) {
    return {
        messageStatus: state.feedback.messageStatus
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            updateModal: modalWindowActions.updateModalWindow,
            sendMessageToSupport: feedbackActions.sendMessageToSupport
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(SendMessageToSupportModal);
